'use client'

import Image from 'next/image'
import { useInView } from '@/hooks/useInView'

/* ── Press Logo Data ──────────────────────────────────────────── */
const PRESS_LOGOS = [
  { name: 'Google News',  src: '/assets/images/press/google_news.webp',  width: 140, height: 36 },
  { name: 'Yahoo Finance',src: '/assets/images/press/yahoo.webp',         width: 120, height: 36 },
  { name: 'FOX Business', src: '/assets/images/press/fox_business.webp',  width: 120, height: 36 },
  { name: 'CBS News',     src: '/assets/images/press/cbs.webp',           width: 80,  height: 36 },
  { name: 'ABC News',     src: '/assets/images/press/abc_news.webp',      width: 100, height: 36 },
  { name: 'USA Today',    src: '/assets/images/press/usa_today.webp',     width: 120, height: 36 },
  { name: 'E! News',      src: '/assets/images/press/e_news.webp',        width: 60,  height: 36 },
  { name: 'Crunchbase',   src: '/assets/images/press/crunchbase.webp',    width: 130, height: 36 },
  { name: 'Bing',         src: '/assets/images/press/bing.webp',          width: 70,  height: 36 },
] as const

export function PressLogoStrip() {
  const { ref, isInView } = useInView()

  // Triple for truly seamless loop
  const tripled = [...PRESS_LOGOS, ...PRESS_LOGOS, ...PRESS_LOGOS]

  return (
    <section
      ref={ref}
      className="relative py-8 sm:py-10 border-t border-b border-zinc-800/30 overflow-hidden"
    >
      {/* Label */}
      <p
        className={`text-center text-[11px] uppercase tracking-[0.2em] text-zinc-600 font-medium mb-6 sm:mb-8 anim-fade-in-up ${isInView ? 'in-view' : ''}`}
      >
        Featured in
      </p>

      {/* Marquee Container */}
      <div
        className={`relative anim-fade-in anim-delay-2 ${isInView ? 'in-view' : ''}`}
      >
        {/* Fade masks */}
        <div className="absolute left-0 top-0 bottom-0 w-20 sm:w-32 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-20 sm:w-32 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none" />

        <div className="overflow-hidden">
          <div className="marquee-track">
            {tripled.map((logo, i) => (
              <div
                key={`${logo.name}-${i}`}
                className="flex-shrink-0 mx-8 sm:mx-12 flex items-center justify-center opacity-40 hover:opacity-80 transition-opacity duration-300 select-none"
                style={{ height: 44 }}
              >
                <Image
                  src={logo.src}
                  alt={logo.name}
                  width={logo.width}
                  height={logo.height}
                  className="w-auto object-contain"
                  style={{ maxHeight: 36, filter: 'brightness(0) invert(1)' }}
                  draggable={false}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
